/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacancyScopeFilter } from './vacancyScopeFilter';


export interface VacancyIncludeFilterItems { 
    relation?: VacancyIncludeFilterItems.RelationEnum;
    scope?: VacancyScopeFilter;
}
export namespace VacancyIncludeFilterItems {
    export type RelationEnum = 'company' | 'requiredBy' | 'authorizedBy' | 'vacancyStatus' | 'personalRequisition' | 'jobPosition' | 'requisitionType' | 'contractType' | 'substitutionType' | 'placeType' | 'authorizedSalaryType' | 'businessUnit';
    export const RelationEnum = {
        Company: 'company' as RelationEnum,
        RequiredBy: 'requiredBy' as RelationEnum,
        AuthorizedBy: 'authorizedBy' as RelationEnum,
        VacancyStatus: 'vacancyStatus' as RelationEnum,
        PersonalRequisition: 'personalRequisition' as RelationEnum,
        JobPosition: 'jobPosition' as RelationEnum,
        RequisitionType: 'requisitionType' as RelationEnum,
        ContractType: 'contractType' as RelationEnum,
        SubstitutionType: 'substitutionType' as RelationEnum,
        PlaceType: 'placeType' as RelationEnum,
        AuthorizedSalaryType: 'authorizedSalaryType' as RelationEnum,
        BusinessUnit: 'businessUnit' as RelationEnum
    };
}


